import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="group fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(31,26,23,0.18)] hover:shadow-[0_14px_40px_rgba(31,26,23,0.24)] transition-shadow focus-ring"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-medium tracking-tight">
        Chat on WhatsApp
      </span>
    </a>
  );
}
